import React from 'react';

import { css } from '@emotion/css';
import { ValidationRuleTemplateDTO } from '@recurrency/core-api-schema/dist/validationRules/getValidationRuleTemplates';
import { theme } from 'theme';

import { Tooltip } from 'components/Tooltip';
import { Typography } from 'components/Typography';

import { TemplateIcon } from './TemplateIcon';

export const TemplateCard = ({
  template,
  selectedTemplate,
  setSelectedTemplate,
}: {
  template: ValidationRuleTemplateDTO;
  selectedTemplate?: ValidationRuleTemplateDTO;
  setSelectedTemplate: (template: ValidationRuleTemplateDTO) => void;
}) => (
  <div
    className={css`
      border: 1px solid ${theme.colors.neutral[200]};
      border-radius: 8px;
      padding: 12px;
      display: flex;
      align-items: flex-start;
      gap: 12px;
      width: 255px;
      min-height: 140px;
      flex-direction: column;
      :hover {
        cursor: pointer;
        background: ${theme.colors.neutral[200]};
      }
      ${selectedTemplate?.templateId === template.templateId ? `background-color: ${theme.colors.neutral[75]};` : ''}
    `}
    onClick={() => setSelectedTemplate(template)}
  >
    <div
      className={css`
        display: flex;
        flex-direction: row;
      `}
    >
      <div
        className={css`
          flex-shrink: 0;
          width: 20px;
          height: 20px;
        `}
      >
        {template.icon && <TemplateIcon icon={template.icon} />}
      </div>

      <Typography type="subtitle" style={{ fontWeight: 600, color: theme.colors.neutral[900], alignContent: 'center' }}>
        {template.name}
      </Typography>
    </div>
    <div
      className={css`
        flex: 1;
      `}
    >
      <Tooltip title={template.description} placement="bottom">
        <Typography
          type="subtitle"
          style={{
            color: theme.colors.neutral[500],
            overflow: 'hidden',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
          }}
        >
          {template.description}
        </Typography>
      </Tooltip>
    </div>
  </div>
);
